import api from './api';

export const agentsService = {
  // Get all agents
  getAll: async (params = {}) => {
    const response = await api.get('/agents', { params });
    return response.data;
  },

  // Get single agent
  getById: async (id) => {
    const response = await api.get(`/agents/${id}`);
    return response.data;
  },
  
  // Get agent profile
  getProfile: async () => {
    const response = await api.get('/agents/profile');
    return response.data;
  },
  
  // Update agent profile
  updateProfile: async (profileData) => {
    const response = await api.put('/agents/profile', profileData);
    return response.data;
  },

  // Change password (in-app, requires current password)
  changePassword: async (passwordData) => {
    const response = await api.put('/agents/profile/password', passwordData);
    return response.data;
  },

  // Get agent applications
  getApplications: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.get('/agents/applications', { params });
    return response.data;
  },

  // Approve application
  approveApplication: async (id) => {
    const response = await api.put(`/agents/applications/${id}/approve`);
    return response.data;
  },

  // Deny application
  denyApplication: async (id, reason) => {
    const response = await api.put(`/agents/applications/${id}/deny`, { reason });
    return response.data;
  },

  // Update agent status
  updateStatus: async (id, status) => {
    const response = await api.put(`/agents/${id}/status`, { status });
    return response.data;
  },

  // Update agent commission
  updateCommission: async (id, commissionPercentage) => {
    const response = await api.put(`/agents/${id}/commission`, { commission_percentage: commissionPercentage });
    return response.data;
  },

  // Alternate emails management
  getAlternateEmails: async (agentId) => {
    const response = await api.get(`/agents/${agentId}/emails`);
    return response.data;
  },

  addAlternateEmail: async (agentId, emailData) => {
    const response = await api.post(`/agents/${agentId}/emails`, emailData);
    return response.data;
  },

  updateAlternateEmail: async (agentId, emailId, updates) => {
    const response = await api.put(`/agents/${agentId}/emails/${emailId}`, updates);
    return response.data;
  },

  deleteAlternateEmail: async (agentId, emailId) => {
    const response = await api.delete(`/agents/${agentId}/emails/${emailId}`);
    return response.data;
  },

  searchByEmail: async (email) => {
    const response = await api.get('/agents/search/by-email', { params: { email } });
    return response.data;
  }
};

export default agentsService;
